import { string, bool, func } from 'prop-types'
import Conditional from '../../../Conditional'
import Tabs from '../../../Tabs'
import { kuiperClassNames, noop } from '../../../utils'

import './styles.scss'

const BucketHeader = ({
  groupOrAble = false,
  id,
  inclusivity,
  onOperationChange = noop,
  title,
}) => (
  <div key={id} className={kuiperClassNames('filter-bucket')}>
    <span className={kuiperClassNames('title')}>{title}</span>
    <div className={kuiperClassNames('spacer')} />
    <Conditional condition={groupOrAble}>
      <Tabs
        name={title}
        theme="switch"
        activeTab={inclusivity ? 1 : 0}
        onChange={(name) => onOperationChange(name === 'all')}
      >
        <span name="any">Any</span>
        <span name="all">All</span>
      </Tabs>
    </Conditional>
  </div>
)

BucketHeader.propTypes = {
  groupOrAble: bool,
  id: string,
  inclusivity: bool,
  onOperationChange: func,
  title: string,
}

export default BucketHeader
